declare global {
    interface Window {
        OneSignal: any;
    }
}

const ONESIGNAL_APP_ID = '0611520e-92d4-4248-be05-0f1a19bd58c7'; // سيتم تغييره لاحقاً

export const initializeOneSignal = () => {
    // التهيئة تتم الآن في index.html
    if (typeof window !== 'undefined' && window.OneSignal) {
        // إضافة tags للمستخدم عند التهيئة
        window.OneSignal.User.addTag("user_type", "subscriber");
    }
};

export const requestNotificationPermission = async () => {
    try {
        if (typeof window === 'undefined' || !window.OneSignal) {
            throw new Error('OneSignal not initialized');
        }

        const permission = await window.OneSignal.Notifications.requestPermission();
        
        if (permission) {
            await window.OneSignal.login(Date.now().toString());
            await window.OneSignal.User.PushSubscription.optIn();
            await window.OneSignal.User.addTag("user_type", "subscriber");
            
            // إعادة تحميل الصفحة بعد الاشتراك لضمان تحديث حالة الاشتراك
            window.location.reload();
        }
        return permission;
    } catch (error) {
        console.error('Error requesting notification permission:', error);
        throw error;
    }
};

export const sendNotification = async (title: string, message: string, url?: string) => {
    try {
        const response = await fetch('https://onesignal.com/api/v1/notifications', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Basic os_v2_app_ayivedus2rberpqfb4nbtpkyy4w4yn5u2vfujtek3qfoblp64umz4pbo7o27poygyd3vtvnf24hv3ncc5jw23drezrxyfggr5nami4i'
            },
            body: JSON.stringify({
                app_id: ONESIGNAL_APP_ID,
                included_segments: ['Subscribed Users'],
                contents: { en: message, ar: message },
                headings: { en: title, ar: title },
                url: url || window.location.origin,
                language: 'ar',
                direction: 'rtl',
                priority: 10,
                ttl: 86400,
                web_push_type: 'Notification',
                isAnyWeb: true,
                firefox_icon: '/logo192.png',
                chrome_web_icon: '/logo192.png',
                chrome_web_badge: '/logo192.png'
            })
        });

        if (!response.ok) {
            const errorData = await response.json();
            console.error('OneSignal API Error:', errorData);
            throw new Error('Failed to send notification');
        }

        return await response.json();
    } catch (error) {
        console.error('Error sending notification:', error);
        throw error;
    }
}; 